import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  modalVisible: false,
  eventType: {
    id: null,
    name: '',
    bookingUrl: '',
    bookingMethod: 'instant',
    kindDescription: '',
    timezone: 'America/New_York'
  },
  email: {
    selectedSpots: []
  },
}

const slice = createSlice({
  name: 'oneOffShare',
  initialState,
  reducers: {
    openModal: (state, action) => ({ ...state, ...action.payload, modalVisible: true }),
    closeModal: () => ({ ...initialState }),
    setBookingUrl: (state, { payload: { bookingUrl } }) => ({ ...state, eventType: { ...state.eventType, bookingUrl } })
  }
})

export const {
  reducer,
  actions: {
    openModal,
    closeModal,
    setBookingUrl
  }
} = slice
